module.exports = __webpack_public_path__ + "static/img/Knight of Swords.30aefa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Knight of Swords.jpg
// module id = 1281
// module chunks = 0